const config = require('./config-prod');

module.exports = config;
